<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/yonghu/bscCustagent',title:'用户管理'},{title:'潜在经销商'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						    <div class="h-thirdColumn w-newColumn">
                    <el-form-item label="区域">
                        <brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :clearable="true"
                                  style="width:100%;"/>
                    </el-form-item>
                    <el-form-item label="渠道">
                        <brselect category="sales_region" :v="q.channelCode" v-model="q.channelCode"
                                  :clearable="true"
                                  style="width:100%;"/>
                    </el-form-item>
                    <el-form-item label="客户名称">
                        <el-input v-model="q.userNameLike"></el-input>
                    </el-form-item>
                    <el-form-item label="领域">
                      <brselect category="swyl_field_custagent" :v="q.custagentFiled" v-model="q.custagentFiled"
                                :clearable="true"
                                style="width:100%;"/>
                    </el-form-item>
						    </div>

                <el-collapse-transition>
                  <div v-show="isScreen">
                    <div class="h-thirdColumn w-newColumn">
                      <el-form-item label="客户所属渠道">
                        <brselect category="channel_custagent" :v="q.custagentChannel" v-model="q.custagentChannel"
                                  :clearable="true"
                                  style="width:100%;"/>
                      </el-form-item>
                      <el-form-item label="拟签约合同类别">
                        <brselect category="contract_type_custagent" :v="q.contractType" v-model="q.contractType"
                                  :clearable="true"
                                  style="width:100%;"/>
                      </el-form-item>
                    </div>
                  </div>
                </el-collapse-transition>


                <div class="l-screenBox">
                  <div class="l-screen" @click="collapseChange">
                    <img :src="isScreen?closeScreen:drawScreen" alt="">
                    <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
                  </div>
                  <div class="l-retrieval">
                    <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                    <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                               @click="adduser">新增客户
                    </el-button>
                  </div>
                </div>



                    </el-form>
                </div>
            </div>
            <div class="h-row">
                <div class="h-rowIn" style="width:100%;">
                    <el-table @selection-change="handleSelectionChange"
                              ref="multipleTable"
                              :data="tableData"
                              stripe
							  :border="true"
							  max-height="450"
                              style="width: 100%">
                        <el-table-column
                                type="selection"
								width="40"
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="userName"
                                label="备用客户名称"
								min-width="200"
                                :show-overflow-tooltip="true"
                                >
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.userName}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="areaCode"
                                :show-overflow-tooltip="true"
                                label="区域">
                            <template slot-scope="scope">
                                {{scope.row.areaCode | dictname('YLRegion')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="city"
                            :show-overflow-tooltip="true"
                            label="地市">
                        </el-table-column>
                        <el-table-column
                                prop="channelCode"
                                :show-overflow-tooltip="true"
                                label="渠道">
                            <template slot-scope="scope">
                                {{scope.row.channelCode | dictname('sales_region')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="contactuserName"
                                :show-overflow-tooltip="true"
                                label="联系人">
                        </el-table-column>
                        <el-table-column
                                prop="telephone"
                                :show-overflow-tooltip="true"
                                label="联系方式">
                        <template slot-scope="scope">
                          <div style="text-align: left;">
                            {{scope.row.telephone}}
                          </div>
                        </template>
                        </el-table-column>
                      <el-table-column
                          prop="custagentFiled"
                          :show-overflow-tooltip="true"
                          min-width="100"
                          label="领域">
                        <template slot-scope="scope">
                          {{scope.row.custagentFiled | dictname('swyl_field_custagent')}}
                        </template>
                      </el-table-column>
                        <el-table-column
                            prop="majorBrands"
                            min-width="100"
                            :show-overflow-tooltip="true"
                            label="主要经营品牌">
                        </el-table-column>
                        <el-table-column
                            prop="custagentChannel"
                            min-width="100"
                            :show-overflow-tooltip="true"
                            label="客户所属渠道">
                          <template slot-scope="scope">
                            {{scope.row.custagentChannel | dictname('channel_custagent')}}
                          </template>
                        </el-table-column>
                        <el-table-column
                            prop="contractType"
                            min-width="100"
                            :show-overflow-tooltip="true"
                            label="拟签约合同类别">
                          <template slot-scope="scope">
                            {{scope.row.contractType | dictname('contract_type_custagent')}}
                          </template>
                        </el-table-column>
                        <el-table-column
                            prop="estimateNum"
                            min-width="100"
                            :show-overflow-tooltip="true"
                            label="预计签约金额(万元)">
                        </el-table-column>
                        <el-table-column
                            prop="estimateContractDate"
                            min-width="100"
                            :show-overflow-tooltip="true"
                            label="预计签约时间">
                        </el-table-column>

                      <el-table-column
                          prop="checkInAddress"
                          :show-overflow-tooltip="true"
                          label="打卡地址">
                      </el-table-column>

                      <el-table-column
                          prop="annualBusinessScale"
                          :show-overflow-tooltip="true"
                          label="年度营业规模">
                      </el-table-column>

                      <el-table-column
                          prop="numberSalePerson"
                          :show-overflow-tooltip="true"
                          label="销售人员数量">
                      </el-table-column>

                        <el-table-column
                            prop="maintainer"
                            :show-overflow-tooltip="true"
                            label="维护人">
                        </el-table-column>
                        <el-table-column
                            prop="dataSource"
                            :show-overflow-tooltip="true"
                            label="数据来源">
                        </el-table-column>

                        <el-table-column
                                prop="cuname"
                                :show-overflow-tooltip="true"
                                label="创建人">
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                :show-overflow-tooltip="true"
								width="160"
                                label="创建时间">
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                width="120">
                            <template slot-scope="scope">
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn" @click="handleEdit(scope.row)">
                                    修改
                                </el-button>
                                <el-button
                                        type="text"
                                        size="small"
                                        class="h-tableLink h-btn" @click="handleDelete(scope.row)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                       @click="exportExcel">批量导出
                            </el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                       @click="uploaddownexcelflagbtn">批量导入
                            </el-button>
                            <!-- <el-button class="h-btn h-formBtn" @click="uploaddownexcelflagbtn">导入Excel</el-button> -->
                            <uploaddownexcel
                                    :visible.sync="uploaddownexcelflag"
                                    v-if="uploaddownexcelflag"
                                    clsname="custagentImportExcel"
                                    :startrow="3" @callback="uploadExcelFilecallback"/>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
            <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible" class="h-dialog2 yonghu" @close="cancel('f')">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell" v-if="this.saveorupdate==1">
                            <h1>新增客户</h1>
                            <p>New Agent</p>
                        </div>
                        <div class="h-tableCell" v-if="this.saveorupdate==2">
                            <h1>修改客户信息</h1>
                            <p>update Agent</p>
                        </div>
                    </div>
                </div>
                <div class="h-formLine h-mrb-38">
                    <el-form :model="f" :rules="rules" ref="f"
                             :inline="true" class="demo-ruleForm h-formbLine h-dialogForm dialogForms">
                        <el-form-item label="经销商名称" class="h-elformWrap-2" prop="userName">
                            <el-input v-model.trim="f.userName" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="区域" class="h-elformWrap-2" prop="areaCode">
                            <brselect category="YLRegion" :v="f.areaCode" v-model="f.areaCode" :clearable="true"
                                      @change="changeArea"
                            />
                        </el-form-item>
                        <el-form-item label="地市" class="h-elformWrap-2" prop="city">
                          <el-select v-model="f.city" filterable clearable
                                     placeholder="地市" style="width: 225px;" @change="changeCity">
                            <el-option
                                v-for="item in cityList"
                                :key="item.city"
                                :label="item.city"
                                :value="item.city">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="渠道" class="h-elformWrap-2" prop="channelCode">
                            <brselect category="sales_region" :v="f.channelCode" v-model="f.channelCode"
                                      :clearable="true"
                            />
                        </el-form-item>
                        <el-form-item label="联系人" class="h-elformWrap-2" prop="contactuserName">
                            <el-input v-model.trim="f.contactuserName" placeholder="请输入"/>
                        </el-form-item>
                        <el-form-item label="联系方式" class="h-elformWrap-2" prop="telephone">
                            <el-input v-model.trim="f.telephone" placeholder="请输入" maxlength="20"
                                      oninput="value=value.replace(/[^\d]/g,'')"/>
                        </el-form-item>
                        <el-form-item label="领域" class="h-elformWrap-2" prop="custagentFiled">
                          <brselect category="swyl_field_custagent" :v="f.custagentFiled" v-model="f.custagentFiled" :clearable="true"
                          />
                        </el-form-item>
                      <el-form-item label="主要经营品牌" class="h-elformWrap-2" prop="majorBrands">
                        <el-input v-model.trim="f.majorBrands" placeholder="请输入"/>
                      </el-form-item>
                      <el-form-item label="维护人" class="h-elformWrap-2" prop="maintainer">
                        <el-input v-model.trim="f.maintainer" placeholder="请输入"/>
                      </el-form-item>
                      <el-form-item label="客户所属渠道" class="h-elformWrap-2" prop="custagentChannel">
                        <brselect category="channel_custagent" :v="f.custagentChannel" v-model="f.custagentChannel" :clearable="true"
                        />
                      </el-form-item>
                      <el-form-item label="拟签约合同类别" class="h-elformWrap-2" prop="contractType">
                        <brselect category="contract_type_custagent" :v="f.contractType" v-model="f.contractType" :clearable="true"
                        />
                      </el-form-item>
                      <el-form-item label="预计签约金额(万元)" class="h-elformWrap-2" prop="estimateNum">
                        <el-input v-model.trim="f.estimateNum" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g,'')"/>
                      </el-form-item>
                      <el-form-item label="预计签约时间" class="h-elformWrap-2" prop="estimateContractDate">
                        <el-date-picker type="date"  value-format="yyyy-MM-dd" placeholder="选择日期" v-model="f.estimateContractDate" style="width: 100%;"></el-date-picker>
                      </el-form-item>
                      <el-form-item label="打卡地址" class="h-elformWrap-2" prop="checkInAddress">
                        <el-input v-model.trim="f.checkInAddress" placeholder="请输入"/>
                      </el-form-item>
                      <el-form-item label="年度营业规模" class="h-elformWrap-2" prop="annualBusinessScale">
                        <el-input v-model.trim="f.annualBusinessScale" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g,'')"/>
                      </el-form-item>
                      <el-form-item label="销售人员数量" class="h-elformWrap-2" prop="numberSalePerson">
                        <el-input v-model.trim="f.numberSalePerson" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g,'')"/>
                      </el-form-item>
                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="cancel('f')">取消</el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ2" @click="insert">提交
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                // 展开折叠筛选
                isScreen: false,
                closeScreen: require("@/assets/images/pimg/closeallic.png"),
                drawScreen: require("@/assets/images/pimg/dobleArr.png"),
                userCode:'',
                areaCode:[],
                //导入Excel
                uploaddownexcelflag: false,
                //新增/修改弹窗
                saveorupdate: null,
                //分页/检索
                q: {
                    areaCode: '',
                    channelCode: '',
                    userNameLike: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表单
                f: {
                    areaCode: null,
                    channelCode: null,
                    userName: null,
                    department: null,
                    contactuserName: null,
                    telephone: null,
                    custagentFiled: null,
                    majorBrands: null,
                    custagentChannel: null,
                    contractType: null,
                    estimateContractDate: null,
                    estimateNum:null,
                    maintainer:null,
                    checkInAddress :null,
                    annualBusinessScale  :null,
                    numberSalePerson :null,
                },
                //表格
                multipleSelection: [],
                cityList: [],      //城市list
                //table列表
                tableData: [],
                //弹窗
                dialogFormVisible: false,
                rules:
                    {
                        userCode: [{required: true, message: '请输入用户编码', trigger: 'blur'}],
                        userName: [{required: true, message: '请输入用户名称', trigger: 'blur'}],
                        areaCode: [{required: true, message: '请选择区域', trigger: 'blur'}],
                        city: [{required: false, message: '请选择地市', trigger: 'blur'}],
                        channelCode: [{required: true, message: '请选择渠道', trigger: 'blur'}],
                        contactuserName: [{required: true, message: '请输入联系人', trigger: 'blur'}],
                        telephone: [{required: true, message: '请输入联系方式', trigger: 'blur'}],
                        maintainer: [{required: true, message: '请输入维护人', trigger: 'blur'}],
                        custagentFiled: [{required: true, message: '请选择领域', trigger: 'blur'}],
                        majorBrands: [{required: true, message: '请输入主要经营品牌', trigger: 'blur'}],
                        custagentChannel: [{required: true, message: '请选择客户所属渠道', trigger: 'blur'}],
                        contractType: [{required: true, message: '请选择拟签约合同类别', trigger: 'blur'}],
                        estimateContractDate: [{required: true, message: '请选择预计签约时间', trigger: 'blur'}],
                        estimateNum: [{required: true, message: '请选择预计签约金额', trigger: 'blur'}],
                        checkInAddress: [{required: false, message: '打卡地址', trigger: 'blur'}],
                        annualBusinessScale: [{required: true, message: '年度营业规模', trigger: 'blur'}],
                        numberSalePerson: [{required: true, message: '销售人员数量', trigger: 'blur'}],
                    }
            }
        },
        created() {
            this.query();
            this.userCode = this._user.usercode;
        },
        methods: {
            //导入Excel
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                this.query();
                this.$msg.msgs(rd.msg);
            },
            //重置检索项
            resetData() {
                this.q.areaCode = '';
                this.q.channelCode = '';
                this.q.userNameLike = '';
            },
            query() {
                ss.customer.seleceAgentPage(this.q).then(rd => {
                    //console.log(rd,"AA");
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            //新增
            adduser() {
                this.f.id = '';
                this.f.userName = '';
                this.f.areaCode = '';
                this.f.channelCode = '';
                this.f.department = '';
                this.f.contactuserName = '';
                this.f.telephone = '';
                this.f.maintainer = '';
                this.f.estimateNum = '';
                this.saveorupdate = 1;
                this.dialogFormVisible = true;
                this.f.checkInAddress = '';
                this.f.annualBusinessScale  = '';
                this.f.numberSalePerson = '';
            },
            //弹框关闭
            cancel(formName) {
                this.dialogFormVisible = false;
                this.f.userName = '';
                this.f.areaCode = '';
                this.f.channelCode = '';
                this.f.department = '';
                this.f.contactuserName = '';
                this.f.telephone = '';
                this.f.maintainer = '';
                this.f.checkInAddress = '';
                this.f.annualBusinessScale  = '';
                this.f.numberSalePerson = '';
                this.$refs[formName].resetFields();
            },
            //新增
            insert() {
                var subflag = false;
                if (this.saveorupdate == 1) {
                    this.$refs['f'].validate((valid) => {
                        if (valid) {
                            subflag = true;
                        } else {
                            this.$msg.msge("请完善信息后再提交！");
                            return false;
                        }
                    });
                } else if (this.saveorupdate == 2) {
                    subflag = true;
                }
                if (subflag == true) {
                    ss.customer.insertAgent(this.f).then(rd => {
                        this.query();
                        this.$msg.msgs(rd.msg);
                        this.dialogFormVisible = false;
                    })
                }
            },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            //删除
            handleDelete(value) {
                this.$msg.confirm("确认删除?", () => {
                    ss.customer.deleteAgentById(value.id).then(rd => {
                        this.query();
                        this.$msg.msgs(rd.msg);
                    });
                });
            },
            //编辑
            handleEdit(value) {
                this.saveorupdate = 2;
                ss.customer.selectAgentById(value.id).then(rd => {
                    this.dialogFormVisible = true;
                    this.f = rd;
                    ss.customer.getAreaCity(this.$getDictName("YLRegion",rd.areaCode)).then(rd => {
                      console.log(rd);
                      this.cityList = rd;
                    })
                })
            },
            changeArea(value){
              if(value != null && value != ''){
                console.log(value.name,"name");
                ss.customer.getAreaCity(value.name).then(rd => {
                  console.log(rd);
                  this.cityList = rd;
                })
              }else {
                this.cityList = [];
              }
              this.f.city = '';
            },
            changeCity(value){
              console.log(value,"name");
              this.f.city = value
              //进行强制数据渲染
              this.$forceUpdate();
            },

          // 展开折叠
          collapseChange() {
            this.isScreen = !this.isScreen;
          },
            //批量导出
   /*         exportExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    idlist.push(element.id);
                });
                updownfile.down("/api/swyl/v1/yonghu/bscCustagent/downloadExcel", idlist, "post", 'data');
            }*/
          exportExcel() {
            updownfile.down("/api/swyl/v1/yonghu/bscCustagent/downloadExcel", this.q, "post", 'data');
          }
        }
    }
</script>

<style>
    .yonghu .h-formbLine .h-elformWrap-2 {
        width: 50%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__label {
        width: 41%;
    }

    .yonghu .h-dialogForm .h-elformWrap-2 .el-form-item__content {
        width: 59%;
    }

    .yonghu .h-formbLine .el-form-item__content .el-select {
        width: 100% !important;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }


    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }
</style>
